import React, { useState, useEffect } from "react";
import FloatingButton from "../components/bottomtotop/FloatingButton";
import logo from "../../assets/images/logo.png";
import { IoMdSearch } from "react-icons/io";
import {
  FaBarsStaggered,
  FaBook,
  FaBox,
  FaBullhorn,
  FaChartLine,
  FaChartPie,
  FaChevronRight,
  FaFileExcel,
  FaImage,
  FaIndustry,
  FaTags,
  FaUser,
  FaXmark,
} from "react-icons/fa6";

import { Link, useLocation } from "react-router-dom";
import {
  FaCog,
  FaFileAlt,
  FaHistory,
  FaShareAlt,
  FaShoppingBag,
  FaShoppingCart,
  FaSlidersH,
  FaTruck,
} from "react-icons/fa";
import SellerSetup from "./setup/SellerSetup";
import BuyerSetup from "./setup/BuyerSetup";
import Dashboard from "./dashboard/Dashboard";
import CategoryNesting from "./categories/CategoryNesting";
import ReorderProducts from "./categories/ReorderProducts";
import Categories from "./categories/Categories";
import Products from "./products/Products";
import Setup from "./setup/Setup";
import ProductVariations from "./products/ProductVariations";
import PublishProduct from "./products/PublishProduct";
import PreperingData from "./PreperingData/PreperingData";
import ExportExcelData from "./ExportExcel/ExportExcelData";
import PhotoLibrary from "./PhotoLibrary/PhotoLibrary";
import Users from "./Users/Users";
import UserPrevelies from "./Users/UserPrevelies";
import Distributor from "./Distributor/Distributor";
import AddingBuyerPanel from "./Buyers/AddingBuyer";
import Buyers from "./Buyers/Buyers";
import BuyerSetting from "./Buyers/BuyerSetting";
import Suppliers from "./Suppliers/Suppliers";
import Orders from "./Orders/Orders";
import OrderActions from "./Orders/OrderActions";
import OrderCarts from "./Orders/OrderCarts";
import AdjustmentCart from "./Orders/AdjustmentCart";
import PreviousOrders from "./Orders/PreviousOrders";
import OrderStatus from "./Orders/OrderStatus";
import ItemisedQuantityReport from "./Orders/ItemisedQuantityReport";
import CompletingOrders from "./Orders/CompletingOrders";
import OrderPreview from "./Orders/OrderPreview";
import ExportingOrders from "./Orders/ExportingOrders";
import ExcelImport from "./Setting/ExcelImport";
import Badges from "./Setting/Badges";
import StockStatus from "./Setting/StockStatus";
import Warehouses from "./Setting/Warehouses";
import Territories from "./Setting/Territories";
import CustomOrderFields from "./Setting/CustomOrderFields";
import Settings from "./Setting/Settings";
import OrderActivity from "./OrderActivity/OrderActivity";
import Reports from "./Reports/Reports";
import ProjectionReport from "./Reports/ProjectionReport";
import GeneralsSet from "./Setting/GeneralsSet";
import PlaceOrder from "./Orders/PlaceOrder";
import ProductAttributes from "./Setting/ProductAttributes";
import ShareAppCode from "./ShareAppCode/ShareAppCode";
import SpreadAWord from "./SpreadAWord/SpreadAWord";
import ProductImage from "./products/ProductImage";
import ProductDocument from "./products/ProductDocument";
import ProductOffer from "./products/ProductOffers";

const Docs = () => {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const location = useLocation();

  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  const menuItems = [
    
    {
      label: "Setup",
      icon: <FaCog />,
      path: "setup",
      submenu: [
        { label: "Seller Setup (For Accepting Orders)", path: "seller-setup" },
        { label: "Buyer Setup (For Placing Orders)", path: "buyer-setup" },
      ],
    },
    {
      label: "Preparing Data for Import",
      icon: <FaFileAlt />,
      path: "PreperingData",
    },
    {
      label: "Importing Excel Data",
      icon: <FaFileExcel />,
      path: "ExportExcelData",
    },

    { label: "Dashboard", icon: <FaChartPie />, path: "dashboard" },
    {
      label: "Categories",
      icon: <FaTags />,
      path: "categories",
      submenu: [
        { label: "Category Nesting", path: "category-nesting" },
        // { label: "Reorder Products", path: "reorder-products" },
        
      ],
    },
    {
      label: "Products",
      icon: <FaBox />,
      path: "products",
      submenu: [
        { label: "Product Variations", path: "ProductVariations" },
        // { label: "Publish Products", path: "PublishProduct" },
        { label: "Product Images", path: "productimage" },
        { label: "Product Document", path: "productdocument" },
        { label: "Product Offers", path: "productoffer" },
      ],
    },

    // { label: "Photo Library", icon: <FaImage />, path: "PhotoLibrary" },
    // {
    //   label: "Users",
    //   icon: <FaUser />,
    //   path: "Users",
    //   submenu: [{ label: "User Privileges", path: "UserPrevelies" }],
    // },
    { label: "Users", icon: <FaUser />, path: "Users" },

    { label: "Distributors", icon: <FaTruck />, path: "Distributor" },
    // {
    //   label: "Buyers",
    //   icon: <FaShoppingCart />,
    //   path: "Buyers",
    //   submenu: [
    //     { label: "Adding Buyers / Inviting Buyers", path: "AddingBuyer" },
    //     { label: "Buyer Settings", path: "BuyerSetting" },
    //   ],
    // },

    { label: "Buyers", icon: <FaShoppingCart />, path: "Buyers" },

    { label: "Suppliers", icon: <FaIndustry />, path: "Suppliers" },
    {
      label: "Orders",
      icon: <FaShoppingBag />,
      path: "Orders",
      submenu: [
        { label: "Placing Orders", path: "PlaceOrder" },
        { label: "Order Actions", path: "OrderActions" },
        { label: "Order Carts", path: "OrderCarts" },
        { label: "Adjustment Cart", path: "AdjustmentCart" },
        // { label: "Previous Orders", path: "previousorders" },
        { label: "Order Status", path: "OrderStatus" },
        { label: "Order Invoice", path: "ItemisedQuantityReport" },
        { label: "Completing Orders", path: "completingorders" },
        { label: "Order Preview", path: "OrderPreview" },
        { label: "Exporting Orders", path: "exportingorders" },
      ],
    },
    { label: "Order Activity", icon: <FaHistory />, path: "OrderActivity" },
    {
      label: "Reports",
      icon: <FaChartLine />,
      path: "Reports",
      submenu: [{ label: "Projection Report", path: "ProjectionReport" }],
    },
    {
      label: "Settings",
      icon: <FaSlidersH />,
      path: "Settings",
      submenu: [
        { label: "General Settings", path: "GeneralsSet" },
        { label: "Product Attributes", path: "ProductAttributes" },
        { label: "Excel Import & Print Order Settings", path: "ExcelImport" },
        { label: "Badges", path: "Badges" },
        // { label: "Stock Status", path: "StockStatus" },
        { label: "Warehouses", path: "Warehouses" },
        // { label: "Territories", path: "Territories" },
        // { label: "Custom Order Fields", path: "CustomOrderFields" },
      ],
    },
    {
      label: "Sharing Your Selzor App Code",
      icon: <FaShareAlt />,
      path: "ShareAppCode",
    },
    {
      label: "Spread a Word About Selzor",
      icon: <FaBullhorn />,
      path: "SpreadAWord",
    },
  ];

  // This effect will open the submenu if one of its children is the current page.
  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    const activeParent = menuItems.find(
      (item) =>
        item.submenu && item.submenu.some((sub) => sub.path === currentPath)
    );
    if (activeParent) {
      setOpenSubmenu(activeParent.label);
    }
  }, [location.pathname]);

  return (
    <div className="bg-gray-50  min-h-screen">
      {/* <div className="bg-gray-50 bg-gray-800 min-h-screen"> */}
      {/* Header */}
      <header className="flex h-20 sticky top-0 z-30 w-full bg-white  border-b">
        {/* <header className="flex h-20 sticky top-0 z-30 w-full bg-white bg-gray-900 border-b"> */}
        <div className="flex items-center justify-between w-full px-4 sm:px-6 md:px-8">
          <div className="flex items-center gap-4">
            <button
              className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-md"
              onClick={() => setIsSidebarOpen(true)}
              aria-label="Open sidebar"
            >
              <FaBarsStaggered className="w-5 h-5" />
            </button>
            <a href="/" className="flex items-center gap-2">
              <img
                src={logo}
                alt="Logo"
                className="block  w-24 h-24 sm:w-24 sm:h-24 md:h-32 md:w-32 lg:w-32 lg:h-32 object-contain"
              />
            </a>
          </div>
          <div className="hidden lg:flex relative items-center bg-tint-base border border-tint rounded-md px-2.5 h-9 w-full max-w-md">
            <IoMdSearch className="text-gray-600 w-5 h-5" />
            <input
              type="text"
              placeholder="Search…"
              className="ml-2 bg-transparent outline-none text-sm w-full"
            />
            <div className="flex gap-1 text-xs ml-auto">
              <kbd className="border rounded px-1">Ctrl</kbd>
              <kbd className="border rounded px-1">K</kbd>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <button
              className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-md"
              onClick={() => setIsSearchOpen(!isSearchOpen)}
              aria-label="Toggle search"
            >
              <IoMdSearch className="w-5 h-5" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Search Bar */}
      {isSearchOpen && (
        <div className="fixed top-20 z-40 w-full bg-white bg-gray-900 border-b p-4 lg:hidden">
          <div className="relative flex items-center border border-gray-300 border-gray-700 rounded-md px-2.5 h-9 w-full">
            <IoMdSearch className="text-gray-600 w-5 h-5" />
            <input
              type="text"
              placeholder="Search…"
              className="ml-2 bg-transparent outline-none text-sm w-full"
              autoFocus
            />
            <button
              onClick={() => setIsSearchOpen(false)}
              className="p-1 ml-2 text-gray-600 hover:bg-gray-100 rounded-md"
              aria-label="Close search"
            >
              <FaXmark className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      <div className="relative flex-grow lg:flex">
        {/* Sidebar */}
        {/* <aside
          className={`fixed inset-y-0 left-0 z-40 w-80 bg-white bg-gray-900 transition-transform duration-300 ease-in-out transform ${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } lg:translate-x-0 lg:sticky lg:top-20 lg:z-20 lg:h-[calc(100vh-80px)] border-r`}
        > */}
        <aside
          className={`fixed inset-y-0 left-0 z-40 w-80 bg-white  transition-transform duration-300 ease-in-out transform ${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } lg:translate-x-0 lg:sticky lg:top-20 lg:z-20 lg:h-[calc(100vh-80px)] border-r`}
        >
          <div className="flex flex-col h-full overflow-y-auto">
            <div
              className="p-4 overflow-y-auto flex-grow scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100"
              style={{
                scrollbarWidth: "thin",
                scrollbarColor: "#9CA3AF #F3F4F6",
              }}
            >
              <style jsx>{`
                /* Webkit scrollbar styles for Chrome, Safari */
                div::-webkit-scrollbar {
                  width: 3px;
                }
                div::-webkit-scrollbar-track {
                  background: #f3f4f6;
                }
                div::-webkit-scrollbar-thumb {
                  background-color: #9ca3af;
                  border-radius: 9999px;
                  border: 0.5px solid transparent;
                }
              `}</style>
              <div className="flex justify-between items-center mb-4 lg:hidden">
                <div className="text-sm font-semibold text-gray-500">
                  <span className="flex items-center gap-2 text-gray-900 text-white">
                    <img src={logo} className="w-24 h-20" alt="Logo" />
                  </span>
                </div>
                <button
                  className="p-2 text-gray-600 hover:bg-gray-100 rounded-md"
                  onClick={() => setIsSidebarOpen(false)}
                  aria-label="Close sidebar"
                >
                  <FaXmark className="w-5 h-5" />
                </button>
              </div>

              {/* Navigation */}
              <nav className="space-y-2 text-sm">
                {menuItems.map((item, index) => {
                  const currentPath = location.pathname;

                  // Check if this menu OR any submenu matches the current path
                  const isActive = item.submenu
                    ? item.submenu.some((subitem) =>
                        currentPath.includes(subitem.path)
                      )
                    : currentPath === `/documentation/${item.path}`;

                  return (
                    <div key={index}>
                      {/* Parent Menu */}
                      <Link
                        to={item.path}
                        className={`flex items-center gap-2 p-2 w-full rounded-md text-base transition-colors
          ${
            isActive
              ? "bg-blue-100 text-white bg-blue-950 text-blue-400"
              : "text-gray-600 hover:bg-[#dbf4f1] text-gray-300 hover:text-white hover:bg-gray-800"
          }
        `}
                        onClick={() => {
                          if (item.submenu) {
                            toggleSubmenu(item.label);
                          }
                          setIsSidebarOpen(false);
                        }}
                      >
                        {item.icon}
                        <span>{item.label}</span>
                        {item.submenu && (
                          <FaChevronRight
                            className={`ml-auto h-3 w-3 transition-transform ${
                              openSubmenu === item.label ? "rotate-90" : ""
                            }`}
                          />
                        )}
                      </Link>

                      {/* Submenu */}
                      {item.submenu && openSubmenu === item.label && (
                        <div className="ml-6 mt-1 space-y-1 text-sm border-l border-gray-200 border-gray-700 pl-2">
                          {item.submenu.map((subitem, subindex) => {
                            const isSubActive = currentPath.includes(
                              subitem.path
                            );
                            return (
                              <Link
                                key={subindex}
                                to={subitem.path}
                                className={`flex items-center gap-1 p-2 rounded-md transition-colors
                  ${
                    isSubActive
                      ? "bg-green-100 text-green-700 bg-blue-900 text-green-300"
                      : "text-gray-500 hover:bg-gray-100 text-gray-400 hover:text-gray-800 hover:bg-gray-200"
                  }
                `}
                                onClick={() => setIsSidebarOpen(false)}
                              >
                                {subitem.label}
                              </Link>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </nav>
            </div>
            
            <div className="mt-auto p-4 border-t border-gray-200 border-gray-700">
              <a
                href="/"
                className="flex items-center font-semibold gap-2 p-3 hover:bg-gray-100 hover:text-gray-800 cursor-pointer text-sm text-gray-500 rounded-md border hover:bg-gray-800 text-gray-400 hover:text-white transition-colors"
              >
                <FaBook className="w-4 h-4" />
                <span>Powered by SelzorDocs</span>
              </a>
            </div>

          </div>
        </aside>

        {/* Main Content Area */}
        <main className="flex-1 p-4 lg:p-8 overflow-y-auto">
          {(() => {
            const path = location.pathname;

            if (path.includes("seller-setup")) return <SellerSetup />;
            if (path.includes("buyer-setup")) return <BuyerSetup />;
            if (path.includes("dashboard")) return <Dashboard />;
            if (path.includes("category-nesting")) return <CategoryNesting />;
            // if (path.includes("reorder-products")) return <ReorderProducts />;
            if (path.includes("categories")) return <Categories />;
            if (path.includes("products")) return <Products />;
            if (path.includes("productdocument")) return <ProductDocument />;
            if (path.includes("productoffer")) return <ProductOffer />;
            if (path.includes("ProductVariations"))
              return <ProductVariations />;
            // if (path.includes("PublishProduct")) return <PublishProduct />;
            if (path.includes("PreperingData")) return <PreperingData />;
            if (path.includes("productimage")) return <ProductImage />;
            if (path.includes("ExportExcelData")) return <ExportExcelData />;
            if (path.includes("PhotoLibrary")) return <PhotoLibrary />;
            if (path.includes("Users")) return <Users />;
            if (path.includes("UserPrevelies")) return <UserPrevelies />;
            if (path.includes("Distributor")) return <Distributor />;
            if (path.includes("AddingBuyer")) return <AddingBuyerPanel />;
            if (path.includes("Buyers")) return <Buyers />;
            if (path.includes("BuyerSetting")) return <BuyerSetting />;
            if (path.includes("Suppliers")) return <Suppliers />;
            if (path.includes("Orders")) return <Orders />;
            if (path.includes("OrderActions")) return <OrderActions />;
            if (path.includes("OrderCarts")) return <OrderCarts />;
            if (path.includes("AdjustmentCart")) return <AdjustmentCart />;
            if (path.includes("PreviousOrders")) return <PreviousOrders />;
            if (path.includes("previousorders")) return <PreviousOrders />;
            if (path.includes("OrderStatus")) return <OrderStatus />;
            if (path.includes("ItemisedQuantityReport"))
              return <ItemisedQuantityReport />;
            if (path.includes("completingorders")) return <CompletingOrders />;

            if (path.includes("OrderPreview")) return <OrderPreview />;
            if (path.includes("exportingorders")) return <ExportingOrders />;
            if (path.includes("ExcelImport")) return <ExcelImport />;
            if (path.includes("Badges")) return <Badges />;
            if (path.includes("StockStatus")) return <StockStatus />;
            if (path.includes("Warehouses")) return <Warehouses />;
            if (path.includes("Territories")) return <Territories />;
            if (path.includes("CustomOrderFields"))
              return <CustomOrderFields />;
            if (path.includes("Settings")) return <Settings />;
            if (path.includes("PlaceOrder")) return <PlaceOrder />;
            if (path.includes("ShareAppCode")) return <ShareAppCode />;

            if (path.includes("OrderActivity")) return <OrderActivity />;
            if (path.includes("GeneralsSet")) return <GeneralsSet />;
            if (path.includes("Reports")) return <Reports />;
            if (path.includes("ProjectionReport")) return <ProjectionReport />;
            if (path.includes("SpreadAWord")) return <SpreadAWord />;
            if (path.includes("ProductAttributes"))
              return <ProductAttributes />;

            if (path === "/documentation" || path === "/documentation/setup")
              return <Setup />;
            return <div className="text-gray-500">Page not found</div>;
          })()}
        </main>
      </div>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      <FloatingButton />
    </div>
  );
};

export default Docs;
